import Vue from 'vue'
import Vuex from 'vuex'
import { user } from '@/modules/users/store'
import { feedback } from './feedback'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: user,
    feedback: feedback
  }
})
